import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import DialogForm from "@/components/modal/DialogForm";

const DetailRow = ({ label, value }) => (
  <Box display="flex" mb={1}>
    <Typography variant="body1" component="span" fontWeight="bold" width="40%">
      {label}:
    </Typography>
    <Typography
      variant="body1"
      component="span"
      sx={(theme) => ({ color: theme.palette.BudgieThemeColor.Neutrals[700] })}
    >
      {value}
    </Typography>
  </Box>
);

function AttendanceInfoViewModal({
  attendanceInfoViewtoggleOpen,
  attendanceInfoViewtoggleClose,
  swipeType,
  empName,
  empId,
  swipeDate,
  swipeInTime,
  swipeOutTime,
  accessCard,
  selectedInfo,
  swipeTime,
}) {
  const formattedInTime = `${swipeInTime}`;
  const formattedOutTime = `${swipeOutTime}`;
  const swipeInOutTime =
    swipeType === "In" ? formattedInTime : formattedOutTime;

  const details = [
    // { label: "Employee Name", value: selectedInfo?.empName },
    { label: "Employee ID", value: selectedInfo?.empId },
    { label: "Swipe Date", value: selectedInfo?.attendanceDate },
    { label: "Swipe Time", value: swipeTime },
    { label: "In/Out", value: swipeType },
    { label: "Access Card Number", value: selectedInfo?.empId },
    { label: "Door/Address", value: "HEPL CSV" },
  ];

  return (
    <DialogForm
      position={"top"}
      open={attendanceInfoViewtoggleOpen}
      setOpen={attendanceInfoViewtoggleClose}
      maxWidth="sm"
      fullWidth
      title="Swipe Details"
    >
      <Box display="flex" flexDirection="column" gap={2}>
        {details.map((detail, index) => (
          <DetailRow key={index} label={detail.label} value={detail.value} />
        ))}
      </Box>
    </DialogForm>
  );
}

AttendanceInfoViewModal.propTypes = {
  attendanceInfoViewtoggleOpen: PropTypes.bool.isRequired,
  attendanceInfoViewtoggleClose: PropTypes.func.isRequired,
  swipeType: PropTypes.string.isRequired,
  empName: PropTypes.string.isRequired,
  empId: PropTypes.string.isRequired,
  swipeDate: PropTypes.string.isRequired,
  swipeInTime: PropTypes.string.isRequired,
  swipeOutTime: PropTypes.string.isRequired,
  accessCard: PropTypes.string.isRequired,
};

export default AttendanceInfoViewModal;
